import { combineReducers } from 'redux';

import sowOrderReducer from '../components/CMS/Shared/SOWOrders/reducer';
import sowOrderDetailReducer from '../components/CMS/Shared/SOWOrders/SOWOrder/reducer';

const sharedReducer = combineReducers({
     sowOrders: sowOrderReducer,
     sowOrderDetail: sowOrderDetailReducer,
});

export default sharedReducer;
